import React, { useContext, useEffect, useState } from "react";
import { makeid } from "utils/random";
import { ContextContentPageMenu } from "./index";

interface IPageMenu extends React.HTMLProps<HTMLElement>{
  component:() => JSX.Element;
  title:string;
  props?: any;
  disabled?: boolean;
  hide?: boolean;
  danger?: boolean;
}

function ContentMenuItem({
  component,
  title,
  props,
  disabled,
  hide,
  danger = false
}:IPageMenu){
  const { 
    setPage,
    addPage,
    removePage
  } = useContext(ContextContentPageMenu);
  const [ item, setItem ] = useState<JSX.Element | null>(null);
  const [ ID ] = useState<string>(`${makeid(7)}-${makeid(5)}`);
  const [ __danger ] = useState<boolean>(danger);

  useEffect(()=>{
    if(!hide){
      let Element = component;
      let item = (
        <Element {...props}/>
      );
      setItem(item);
    }
  },[props, component, hide]);

  useEffect(()=>{
    if(addPage && item){
      addPage(ID, item);
    }

    return ()=>{
      if(removePage){
        removePage(ID);
      }
    }
  },[addPage, removePage, item, ID]);
  
  if(hide) return <></>;

  return (
    <div id={`pagedefault-menu-item-${ID}`} className={"pagedefault-menu-item "+(disabled?"pagedefault-menu-item-disabled":"")+(__danger?" pagedefault-menu-item-danger":"")} onClick={
      !disabled?
      (e)=>{
        setTimeout(()=>{
          let element = e.target;
          if (element instanceof Element) {
            element.classList.remove("pagedefault-menu-item-danger");
          }
          
        },1000);
        if(setPage)setPage(ID);
      }
      :()=>{}
    }>
      {title}
    </div>
  );
}

export default ContentMenuItem;

